import PasswordInput from '../../components/PasswordInput';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import api from '../../services/api';
import toast from 'react-hot-toast';
import {
  PlusIcon, XMarkIcon, CheckCircleIcon, NoSymbolIcon,
  MagnifyingGlassIcon, TrashIcon,
} from '@heroicons/react/24/outline';

const fmtDate = d => d ? new Date(d).toLocaleDateString('en-PK',{day:'numeric',month:'short',year:'numeric'}) : 'Never';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
  .so * { box-sizing:border-box; }
  .so { font-family:'Sora',sans-serif; color:#1a1d2e; animation:soFade .4s ease both; }
  @keyframes soFade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:none} }
  .so-hdr { display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:1.5rem; flex-wrap:wrap; gap:1rem; }
  .so-title { font-size:1.35rem; font-weight:700; color:#0f1123; letter-spacing:-.02em; }
  .so-sub   { font-size:.76rem; color:#9094a8; margin-top:3px; }
  .btn-create { display:inline-flex; align-items:center; gap:7px; padding:9px 18px; border:none; border-radius:10px; background:#7c3aed; color:white; font-family:'Sora',sans-serif; font-size:.82rem; font-weight:600; cursor:pointer; }
  .btn-create:hover { background:#6d28d9; }
  .btn-create svg { width:15px; height:15px; stroke-width:2; }
  .so-search-wrap { position:relative; margin-bottom:1.4rem; }
  .so-search-wrap svg { position:absolute; left:14px; top:50%; transform:translateY(-50%); width:16px; height:16px; stroke:#9094a8; pointer-events:none; }
  .so-search { font-family:'Sora',sans-serif; font-size:.84rem; width:100%; max-width:380px; padding:10px 14px 10px 40px; border:1.5px solid #e4e7f0; border-radius:12px; background:white; color:#1a1d2e; outline:none; }
  .so-search:focus { border-color:#7c3aed; }
  .panel { background:white; border-radius:16px; border:1px solid #e8ebf4; overflow:hidden; }
  .tbl { width:100%; border-collapse:collapse; }
  .tbl thead { background:#fafbff; border-bottom:1px solid #edf0f9; }
  .tbl th { padding:10px 16px; text-align:center !important; font-size:.65rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.07em; white-space:nowrap; }
  .tbl tbody tr { border-bottom:1px solid #f3f5fb; transition:background .12s; }
  .tbl tbody tr:last-child { border-bottom:none; }
  .tbl tbody tr:hover { background:#fafbff; }
  .tbl td { padding:12px 16px; font-size:.8rem; vertical-align:middle; text-align:center !important; }
  .owner-avatar { width:34px; height:34px; border-radius:10px; background:linear-gradient(135deg,#7c3aed,#4f46e5); display:flex; align-items:center; justify-content:center; font-size:.76rem; font-weight:700; color:white; flex-shrink:0; }
  .pill-active   { font-size:.65rem; font-weight:600; padding:2px 9px; border-radius:99px; background:#ecfdf5; color:#10c98e; display:inline-flex; }
  .pill-inactive { font-size:.65rem; font-weight:600; padding:2px 9px; border-radius:99px; background:#fef2f2; color:#ef4444; display:inline-flex; }
  .school-chip { font-size:.65rem; font-weight:600; padding:2px 8px; border-radius:99px; background:#f5f3ff; color:#7c3aed; display:inline-flex; margin:2px; }

  .btn-toggle { width:30px; height:30px; border-radius:8px; cursor:pointer; display:flex; align-items:center; justify-content:center; border:1px solid; font-size:.72rem; font-weight:700; transition:all .15s; }
  .btn-toggle svg { width:14px; height:14px; stroke-width:2; }
  .btn-toggle:disabled { opacity:.5; cursor:not-allowed; }
  .action-btn { width:30px; height:30px; border-radius:8px; border:1px solid #e4e7f0; background:white; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:all .15s; }
  .action-btn svg { width:14px; height:14px; stroke-width:2; }
  .action-btn:hover { background:#fef2f2; border-color:#fecaca; color:#ef4444; }
  .empty { text-align:center; padding:3rem 2rem; color:#9094a8; font-size:.82rem; }
  .loading { display:flex; align-items:center; justify-content:center; height:200px; gap:10px; color:#9094a8; }
  .spin { width:18px; height:18px; border:2px solid #e4e7f0; border-top-color:#7c3aed; border-radius:50%; animation:sp .7s linear infinite; }
  @keyframes sp { to{transform:rotate(360deg)} }
  /* Modal */
  .mb { position:fixed; inset:0; background:rgba(10,12,28,.65); backdrop-filter:blur(5px); display:flex; align-items:center; justify-content:center; z-index:9999; padding:20px; }
  .mo { background:white; border-radius:20px; width:100%; max-width:520px; max-height:90vh; display:flex; flex-direction:column; box-shadow:0 25px 60px rgba(0,0,0,.25); animation:moIn .25s ease; overflow:hidden; }
  @keyframes moIn { from{opacity:0;transform:scale(.94)} to{opacity:1;transform:scale(1)} }
  .mo-hd { display:flex; align-items:center; justify-content:space-between; padding:18px 22px; border-bottom:1px solid #f0f2f8; flex-shrink:0; }
  .mo-title { font-size:1rem; font-weight:700; color:#0f1123; }
  .mo-x { width:28px; height:28px; border-radius:7px; border:none; background:#f0f2f7; cursor:pointer; display:flex; align-items:center; justify-content:center; }
  .mo-x svg { width:14px; height:14px; stroke-width:2; }
  .mo-bd { padding:20px 22px; flex:1; overflow-y:auto; }
  .mo-ft { display:flex; gap:8px; justify-content:flex-end; padding:14px 22px; border-top:1px solid #f0f2f8; }
  .ff { display:flex; flex-direction:column; gap:5px; margin-bottom:12px; }
  .fl { font-size:.68rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.06em; }
  .fi { font-family:'Sora',sans-serif; font-size:.82rem; padding:9px 11px; border:1.5px solid #e0e4f0; border-radius:9px; background:#f8f9fc; color:#1a1d2e; outline:none; width:100%;min-width:0; }
  .fi:focus { border-color:#7c3aed; background:white; }
  .fg { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
  .form-grid > *, .fg > * { min-width:0; }
  .btn-purple { display:inline-flex; align-items:center; gap:7px; padding:9px 18px; border:none; border-radius:10px; background:#7c3aed; color:white; font-family:'Sora',sans-serif; font-size:.82rem; font-weight:600; cursor:pointer; }
  .btn-purple:hover { background:#6d28d9; }
  .btn-ghost  { display:inline-flex; align-items:center; gap:7px; padding:9px 18px; border:none; border-radius:10px; background:#f0f2f7; color:#6b7194; font-family:'Sora',sans-serif; font-size:.82rem; font-weight:600; cursor:pointer; }
  .btn-ghost:hover { background:#e4e7f0; }
  .school-check { display:flex; align-items:center; gap:10px; padding:8px 10px; border-radius:9px; cursor:pointer; border:1.5px solid #e8ebf4; margin-bottom:6px; transition:border-color .15s; }
  .school-check:hover { border-color:#c4b5fd; background:#faf8ff; }
  .school-check.checked { border-color:#7c3aed; background:#faf8ff; }
  .school-check-box { width:18px; height:18px; border-radius:5px; border:2px solid #e0e4f0; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .school-check-box.checked { background:#7c3aed; border-color:#7c3aed; }
  .school-check-box svg { width:11px; height:11px; stroke:white; stroke-width:3; }

  /* Mobile cards */
  .so-cards { display:none; padding:10px; }
  .so-card { background:white; border-radius:12px; border:1px solid #e8ebf4; padding:13px; margin-bottom:8px; }
  .so-card-top { display:flex; align-items:center; justify-content:space-between; gap:8px; margin-bottom:8px; }
  .so-card-row { display:flex; justify-content:space-between; align-items:center; font-size:.78rem; padding:5px 0; border-bottom:1px solid #f3f5fb; gap:8px; }
  .so-card-row:last-of-type { border-bottom:none; }
  .so-card-label { color:#9094a8; font-weight:600; font-size:.68rem; text-transform:uppercase; letter-spacing:.05em; flex-shrink:0; }
  .so-card-actions { display:flex; gap:6px; margin-top:10px; }
  @media (max-width:768px) {
    .tbl-wrap { display:none !important; }
    .so-cards { display:block; }
    .fg { grid-template-columns:1fr; }
  }
`;

const getInitials = n => n?.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase()||'O';

export default function SuperOwners() {
  const [owners,  setOwners]  = useState([]);
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
  const [modal,   setModal]   = useState(false);
  const [saving,  setSaving]  = useState(false);
  const [toggling, setToggling] = useState({});
  const [form,    setForm]    = useState({ name:'', email:'', password:'', schoolIds:[] });

  useEffect(() => {
    Promise.all([
      api.get('/super/owners'),
      api.get('/super/schools'),
    ]).then(([o, s]) => {
      setOwners(o.data?.owners || o.data || []);
      setSchools(s.data?.schools || s.data || []);
    }).catch(() => toast.error('Failed to load'))
    .finally(() => setLoading(false));
  }, []);

  const toggleSchool = (id) => {
    setForm(p => ({
      ...p,
      schoolIds: p.schoolIds.includes(id) ? p.schoolIds.filter(s => s !== id) : [...p.schoolIds, id],
    }));
  };

  const handleCreate = async () => {
    if (!form.email || !form.password) return toast.error('Email and password required');
    setSaving(true);
    try {
      const { data } = await api.post('/super/owners', form);
      setOwners(p => [data.owner, ...p]);
      setModal(false);
      setForm({ name:'', email:'', password:'', schoolIds:[] });
      toast.success('Owner account created');
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this owner account?')) return;
    try {
      await api.delete(`/super/owners/${id}`);
      setOwners(p => p.filter(o => o._id !== id));
      toast.success('Owner deleted');
    } catch { toast.error('Failed'); }
  };

  const filtered = owners.filter(o =>
    !search ||
    o.name?.toLowerCase().includes(search.toLowerCase()) ||
    o.email?.toLowerCase().includes(search.toLowerCase())
  );


  const handleToggle = async (ownerId) => {
    setToggling(p => ({...p, [ownerId]: true}));
    try {
      const { data } = await api.put(`/super/users/${ownerId}/toggle-active`);
      toast.success(data.message);
      setOwners(p => p.map(o => o._id === ownerId ? {...o, isActive: data.isActive} : o));
    } catch { toast.error('Failed'); }
    finally { setToggling(p => ({...p, [ownerId]: false})); }
  };

  return (
    <div className="so"><style>{css}</style>
      <div className="so-hdr">
        <div>
          <div className="so-title">School Owners</div>
          <div className="so-sub">Create and manage owner accounts. Owners can access and manage their assigned branches.</div>
        </div>
        <button className="btn-create" onClick={() => setModal(true)}><PlusIcon />Create Owner</button>
      </div>

      <div className="so-search-wrap">
        <MagnifyingGlassIcon />
        <input className="so-search" placeholder="Search owners…" value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div className="panel">
        {loading ? (
          <div className="loading"><div className="spin"/>Loading…</div>
        ) : filtered.length === 0 ? (
          <div className="empty">{search ? 'No owners found.' : 'No owner accounts yet. Create one to get started.'}</div>
        ) : (
          <div className="tbl-wrap">
            <table className="tbl">
              <thead><tr>
                <th>Owner</th><th>Email</th><th>Branches</th><th>Status</th><th>Last Login</th><th></th>
              </tr></thead>
              <tbody>
                {filtered.map(owner => (
                  <tr key={owner._id}>
                    <td>
                      <div style={{display:'flex',alignItems:'center',gap:10}}>
                        <div className="owner-avatar">{getInitials(owner.name)}</div>
                        <div>
                          <div style={{fontWeight:600,color:'#0f1123'}}>{owner.name||'—'}</div>
                          <div style={{fontSize:'.68rem',color:'#9094a8',fontFamily:"'JetBrains Mono',monospace"}}>{String(owner._id ?? '').slice(-8)}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{color:'#6b7194',fontSize:'.78rem'}}>{owner.email}</td>
                    <td>
                      {(owner.schools||[]).length === 0
                        ? <span style={{color:'#b0b5cc',fontSize:'.74rem'}}>No branches assigned</span>
                        : (owner.schools||[]).map(s => (
                            <span key={s._id||s} className="school-chip">{s.name||s}</span>
                          ))}
                    </td>
                    <td><span className={owner.isActive!==false?'pill-active':'pill-inactive'}>{owner.isActive!==false?'Active':'Inactive'}</span></td>
                    <td style={{fontSize:'.74rem',color:'#9094a8'}}>{fmtDate(owner.lastLogin)}</td>
                    <td>
                      <button
                        className={`action-btn ${owner.isActive!==false?'deactivate':'activate'}`}
                        onClick={() => handleToggle(owner._id)}
                        disabled={toggling[owner._id]}
                        title={owner.isActive!==false?'Deactivate':'Activate'}
                        style={{color:owner.isActive!==false?'#ef4444':'#10c98e',borderColor:owner.isActive!==false?'#fecaca':'#a7f3d0',background:owner.isActive!==false?'#fef2f2':'#ecfdf5'}}>
                        {toggling[owner._id]?'…':owner.isActive!==false?<NoSymbolIcon />:<CheckCircleIcon />}
                      </button>
                      <button className="action-btn" onClick={() => handleDelete(owner._id)} title="Delete">
                        <TrashIcon />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Mobile cards */}
        {!loading && filtered.length > 0 && (
          <div className="so-cards">
            {filtered.map(owner => (
              <div className="so-card" key={owner._id}>
                <div className="so-card-top">
                  <div style={{display:'flex',alignItems:'center',gap:10}}>
                    <div className="owner-avatar">{getInitials(owner.name)}</div>
                    <div>
                      <div style={{fontWeight:600,color:'#0f1123'}}>{owner.name||'—'}</div>
                      <div style={{fontSize:'.68rem',color:'#9094a8',fontFamily:"'JetBrains Mono',monospace"}}>{String(owner._id ?? '').slice(-8)}</div>
                    </div>
                  </div>
                  <span className={owner.isActive!==false?'pill-active':'pill-inactive'}>{owner.isActive!==false?'Active':'Inactive'}</span>
                </div>
                <div className="so-card-row"><span className="so-card-label">Email</span><span style={{color:'#6b7194',fontSize:'.78rem'}}>{owner.email}</span></div>
                <div className="so-card-row"><span className="so-card-label">Branches</span>
                  <span style={{textAlign:'right'}}>
                    {(owner.schools||[]).length === 0
                      ? <span style={{color:'#b0b5cc',fontSize:'.74rem'}}>None assigned</span>
                      : (owner.schools||[]).map(s => (
                          <span key={s._id||s} className="school-chip">{s.name||s}</span>
                        ))}
                  </span>
                </div>
                <div className="so-card-row"><span className="so-card-label">Last Login</span><span style={{fontSize:'.74rem',color:'#9094a8'}}>{fmtDate(owner.lastLogin)}</span></div>
                <div className="so-card-actions">
                  <button
                    className="action-btn"
                    onClick={() => handleToggle(owner._id)}
                    disabled={toggling[owner._id]}
                    title={owner.isActive!==false?'Deactivate':'Activate'}
                    style={{color:owner.isActive!==false?'#ef4444':'#10c98e',borderColor:owner.isActive!==false?'#fecaca':'#a7f3d0',background:owner.isActive!==false?'#fef2f2':'#ecfdf5'}}>
                    {toggling[owner._id]?'…':owner.isActive!==false?<NoSymbolIcon />:<CheckCircleIcon />}
                  </button>
                  <button className="action-btn" onClick={() => handleDelete(owner._id)} title="Delete">
                    <TrashIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Create Owner Modal */}
      {modal && createPortal(
        <div className="mb" onClick={() => setModal(false)}>
          <div className="mo" onClick={e => e.stopPropagation()}>
            <div className="mo-hd">
              <div className="mo-title">Create Owner Account</div>
              <button className="mo-x" onClick={() => setModal(false)}><XMarkIcon /></button>
            </div>
            <div className="mo-bd">
              <div className="fg">
                <div className="ff" style={{gridColumn:'1/-1'}}>
                  <label className="fl">Full Name</label>
                  <input className="fi" placeholder="e.g. Ahmed Khan" value={form.name} onChange={e => setForm(p=>({...p,name:e.target.value}))} />
                </div>
                <div className="ff">
                  <label className="fl">Email *</label>
                  <input type="email" className="fi" placeholder="owner@email.com" value={form.email} onChange={e => setForm(p=>({...p,email:e.target.value}))} />
                </div>
                <div className="ff">
                  <label className="fl">Password *</label>
                  <PasswordInput className="fi" placeholder="Min 6 characters" value={form.password} onChange={e => setForm(p=>({...p,password:e.target.value}))} />
                </div>
              </div>
              <div className="ff" style={{marginTop:4}}>
                <label className="fl">Assign Branches (optional)</label>
                <div style={{fontSize:'.72rem',color:'#9094a8',marginBottom:8}}>Select which schools this owner can manage. You can assign more later.</div>
                {schools.length === 0 ? (
                  <div style={{fontSize:'.78rem',color:'#9094a8',padding:'8px',background:'#f8f9fc',borderRadius:8}}>No schools yet. Create schools first.</div>
                ) : schools.map(s => (
                  <div key={s._id} className={`school-check${form.schoolIds.includes(s._id)?' checked':''}`} onClick={() => toggleSchool(s._id)}>
                    <div className={`school-check-box${form.schoolIds.includes(s._id)?' checked':''}`}>
                      {form.schoolIds.includes(s._id) && <CheckCircleIcon />}
                    </div>
                    <div>
                      <div style={{fontSize:'.82rem',fontWeight:600,color:'#0f1123'}}>{s.name}</div>
                      {s.address && <div style={{fontSize:'.68rem',color:'#9094a8'}}>{s.address}</div>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mo-ft">
              <button className="btn-ghost" onClick={() => setModal(false)}>Cancel</button>
              <button className="btn-purple" onClick={handleCreate} disabled={saving}>
                {saving ? 'Creating…' : 'Create Owner'}
              </button>
            </div>
          </div>
        </div>
      , document.body)}
    </div>
  );
}